// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/common.less'
import dataV from '@jiaminghi/data-view'
import './utils/flexible'
import VueI18n from "vue-i18n"
import zh from './lang/zh'
import en from './lang/en'
import BaiduMap from 'vue-baidu-map'
import echarts from 'echarts'
import VueParticles from 'vue-particles'
import commonFun from "./tool/commonFun"
import MeteSoilCommon from "./tool/MeteSoilCommon";
import SporePestCommon from "./tool/SporePestCommon";
import updatePwd from "./components/popup/updatePwd";
import operate from "./components/popup/deviceOperate";
import lamp from "./components/popup/lampOperation";
import stateInfo from "./components/popup/stateInfo";
import App from './App'
import router from './router'
Vue.prototype.$popup = updatePwd.install;
Vue.prototype.$operate = operate.install;
Vue.prototype.$lamp = lamp.install;
Vue.prototype.$stateInfo = stateInfo.install;
Vue.prototype.$echarts = echarts;
Vue.prototype.$commonFun = commonFun;
Vue.prototype.$MeteSoilCommon = MeteSoilCommon;
Vue.prototype.$SporePestCommon = SporePestCommon;

Vue.use(dataV);
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(VueParticles);

Vue.use(BaiduMap, {
  ak: 'abO7BTVblphYlMMuzi4REM1lrfufKDHq'
})

const i18n = new VueI18n({
  locale:'zh-CN',
  silentTranslationWarn: true,
  messages: {
    'zh-CN': zh,
    'en-US': en
  },
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js